import React from 'react';
import { Divider, DividerProps } from 'antd';

function DividerStyled({ children, ...rest }: DividerProps) {
  return <Divider orientation="left" {...rest}>{children}</Divider>;
}

interface PageSectionProps extends React.PropsWithChildren {
  title: React.ReactNode;
  className?: string;
  dividerStyle?: React.CSSProperties;
}

function PageSection({
  title, className, dividerStyle, children,
}: PageSectionProps) {
  return (
    <div className={className}>
      <DividerStyled style={dividerStyle}>{title}</DividerStyled>
      <div>
        {children}
      </div>
    </div>
  );
}

export default PageSection;
